<nav *ngIf="menuStack?.length">
  <div class="tablist-wrapper">
    <button *ngIf="canScrollLeft" type="button" class="tablist-arrow left"
    (click)="scrollBy(-1)">
      <i class="material-symbols-rounded">chevron_left</i>
    </button>
    <div #nav class="tablist no-select" role="tablist"
    (scroll)="updateScrollState()"
    (wheel)="onWheel($event)">
      <ul class="inner">
        <li *ngFor="let item of menuStack"
        class="tablist-tab"
        [class.active]="item.id === activeNavTab?.id"
        [routerLink]="item.router_link"
        [queryParams]="item.query_params">
          <i *ngIf="item.icon" class="material-symbols-rounded">{{ item.icon }}</i>
          {{ item.label|translate }}
        </li>
      </ul>
    </div>
    <button *ngIf="canScrollRight" type="button" class="tablist-arrow right"
    (click)="scrollBy(1)">
      <i class="material-symbols-rounded">chevron_right</i>
    </button>
  </div>
</nav>
